<template>
  <div
    class="hover:bg-gray-100 cursor-pointer px-3 py-1 rounded-md"
    :data-test="data_test"
    :class="{ 'opacity-50 !cursor-not-allowed': disabled }"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script setup>
import 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  data_test: { type: String, default: '' },
  disabled: { type: Boolean },
});

const onClick = () => {
  if (props.disabled) return;
  emit('click');
};
</script>
